import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hrms13x/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hrms13x/labels')
  },
  getIndex (searchParams) {
    if (isMock) return generator(mocker.index())
    let sendParams = {}
    if (typeof searchParams !== 'undefined') {
      sendParams = {
        p_codempid_query: (typeof searchParams.codempid !== 'undefined' ? searchParams.codempid : ''),
        p_codcomp: (typeof searchParams.codcomp2 !== 'undefined' ? searchParams.codcomp2 : ''),
        p_sql_statement: (typeof searchParams.syncond.code !== 'undefined' ? searchParams.syncond.code : '')
      }
    } else {
      return generator({
        total: 0,
        rows: []
      })
    }
    return instance().get(endpoint + '/hrms13x/index', { params: sendParams })
  },
  getDetail (searchParams) {
    if (isMock) return generator(mocker.detail())
    let codempidQuery = ''
    if (typeof searchParams !== 'undefined') {
      codempidQuery = (typeof searchParams.codempid !== 'undefined' ? searchParams.codempid : '')
    }
    return instance().get(endpoint + '/stdemp/index/' + codempidQuery)
  },
  getListFields () {
    if (isMock) return generator(mocker.listFields())
    return instance().get(endpoint + '/hrms13x/listFields')
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms13x/index.js